import { render, staticRenderFns } from "./AccidentTable.vue?vue&type=template&id=64e87c2e&scoped=true&"
import script from "./AccidentTable.vue?vue&type=script&lang=js&"
export * from "./AccidentTable.vue?vue&type=script&lang=js&"
import style0 from "./AccidentTable.vue?vue&type=style&index=0&id=64e87c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e87c2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VFlex,VLayout})
